module.exports = __webpack_public_path__ + "static/media/Alie.bfafb7f4.png";